import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-admin-siths-eid-base',
  templateUrl: './admin-siths-eid-base.component.html',
  styleUrls: ['./admin-siths-eid-base.component.scss']
})
export class AdminSithsEidBaseComponent {}
